import { debugLog } from './utils'

function wrapedCb (cb) {
  return cb || (xhr => { debugLog('DEAFULT CALLBACK', xhr, this) })
}

export function ajax (args = {}) {
  let xhr = new XMLHttpRequest()

  xhr.onerror = wrapedCb(args.errorCb).bind('XHR network error')
  xhr.onreadystatechange = e => {
    if (xhr.readyState === 4) {
      if (xhr.status === 200 || xhr.status === 201) {
        wrapedCb(args.successCb)(JSON.parse(xhr.response))
      } else {
        wrapedCb(args.errorCb).call('XHR server error', xhr)
      }
    }
  }

  xhr.open(args.method, args.url, true)
  xhr.setRequestHeader('Content-Type', 'application/json')
  xhr.send(JSON.stringify(args.data))
}



// WEBPACK FOOTER //
// ./app/common/ajax.js